













import * as rive from '@rive-app/canvas';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';

const STATE_MACHINE_ENTRYPOINT = 'Dog animation'; // defined in the Rive file / editor

@Component({})
export default class LessonLoadingScreen extends Vue {
  private mounted(): void {
    this.initializeLoadingAnimation();
  }

  private initializeLoadingAnimation(): void {
    const riveInstance = new rive.Rive({
      src: '/site_media/version-0/images/lessons/tangrams.riv',
      canvas: this.$refs.canvas as HTMLCanvasElement,
      layout: new rive.Layout({
        fit: rive.Fit.Cover,
        alignment: rive.Alignment.Center,
      }),
      stateMachines: STATE_MACHINE_ENTRYPOINT,
      autoplay: true,
      onLoad: () => {
        riveInstance.resizeDrawingSurfaceToCanvas();
      },
    });
  }

  private onCloseClicked(): void {
    this.$emit('closeClicked');
  }
}
